import { render, staticRenderFns } from "./TranslationsGroupHead.vue?vue&type=template&id=e4780542"
import script from "./TranslationsGroupHead.vue?vue&type=script&lang=js"
export * from "./TranslationsGroupHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports